import React from 'react'
import { Dialog, Button } from '@intugine-technologies/mui'
import MuiTypography from '@mui/material/Typography'
import MuiBox from '@mui/material/Box'
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../hooks/useConfig';
import { useProductConfig } from '../../context/ProductConfigContext';
// import { useAuth } from 'react-oidc-context'

const ConfirmationPopUp = ({ open, setClose, handleStorageChange }) => {
  const navigate = useNavigate();
  const { removeConfig } = useConfig();
  const { clearFeatureConfig } = useProductConfig();
  // const auth = useAuth()

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    removeConfig();
    localStorage.removeItem('otp_generated');
    localStorage.removeItem('idp_details');
    localStorage.removeItem('user_details');
    localStorage.removeItem('processed_auth_code');
    localStorage.removeItem('feature_config');
    localStorage.removeItem('auth_process_active');
    localStorage.removeItem('auth_process_time');
    localStorage.removeItem('intended_destination');
    // Dispatch custom event to notify components
    window.dispatchEvent(new CustomEvent('authProcessChange', { 
      detail: { isInAuthProcess: false } 
    }));
    clearFeatureConfig();
    setClose();
    navigate('/login');
    
    // Call handleStorageChange directly to update the state
    handleStorageChange(); // Ensure to define this function in the appropriate scope
  }
  return (
    <Dialog
      open={open}
      setClose={setClose}
      heading="Confirmation"
      width="496px"
      height="104px"
      buttonAction={
        <>
          <Button
            text="Cancel"
            size="small"
            variant="outlined"
            color="secondary"
            onClick={setClose}
          />
          <Button
            text="Log Out"
            size="small"
            variant="contained"
            color="error"
            sx={{ marginLeft: '24px' }}
            onClick={handleLogout}
          />
        </>
      }
    >
      <MuiBox sx={{ margin: '40px' }}>
        <MuiTypography variant="subtitle2">Are you sure you want to Log Out?</MuiTypography>
      </MuiBox>
    </Dialog>
  )
}

export default ConfirmationPopUp
